import { useInfiniteQuery } from "@tanstack/react-query";

import { useScrollFetchRef } from "@shared/libs/api-client/hooks";

import {
  type UseRequisitesListParams,
  requisitesListQueryOptions,
} from "./requisite-list-query-options";

export const useRequisitesList = (params: UseRequisitesListParams = {}) => {
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    refetch,
    isFetchingNextPage,
    isPending,
  } = useInfiniteQuery(requisitesListQueryOptions(params));
  const loadMoreRef = useScrollFetchRef({
    fetch: fetchNextPage,
    hasNext: hasNextPage,
    isFetching: isFetchingNextPage,
  });

  return {
    error,
    loadMoreRef,
    pagination: data?.pagination,
    refetch,
    requisites: data?.list || [],
    sort: data?.sort || [],
    isFetchingNextPage,
    isLoading: isPending || isFetchingNextPage,
    isPending,
  };
};
